import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from './Pages/Home';
import PageLayOut from "./Pages/PageLayOut";
import News from "./Pages/NewsPage";
import LatestNewsPage from "./Pages/LatestNewsPage";
import NewsDetails from "./Pages/NewsDetails";
import About from "./Pages/About";
import Career from "./Pages/Career";
import ContactUs from "./Pages/ContactUs";
import OurServices from "./Pages/OurServices";
import NewNews from "./components/News/News";
import Projects from "./Pages/Projects";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PageLayOut />} >
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="career" element={<Career /> } />
          <Route path="/our-services" element={<OurServices />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/latest-news" element={<LatestNewsPage />} />
          <Route path="/news" element={<News />} />
          <Route path="/news-details/:id" element={<NewsDetails />} />
          <Route path="/new-news" element={<NewNews />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
